import React, { useState, createContext, useContext } from 'react';
type TabsContextType = {
  value: string;
  onValueChange: (value: string) => void;
};
const TabsContext = createContext<TabsContextType | null>(null);
interface TabsProps {
  defaultValue: string;
  children: React.ReactNode;
}
export const Tabs: React.FC<TabsProps> = ({
  defaultValue,
  children
}) => {
  const [value, setValue] = useState(defaultValue);
  return <TabsContext.Provider value={{
    value,
    onValueChange: setValue
  }} data-id="element-11354">
      <div className="w-full" data-id="element-11355">{children}</div>
    </TabsContext.Provider>;
};
export const TabsList: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  return <div className="flex border-b border-gray-200 dark:border-gray-700 mb-4" data-id="element-11356">
      {children}
    </div>;
};
export const TabsTrigger: React.FC<{
  value: string;
  children: React.ReactNode;
}> = ({
  value,
  children
}) => {
  const context = useContext(TabsContext);
  if (!context) throw new Error('TabsTrigger must be used within a Tabs component');
  const {
    value: selectedValue,
    onValueChange
  } = context;
  const isSelected = selectedValue === value;
  return <button className={`px-4 py-2 text-sm font-medium ${isSelected ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => onValueChange(value)} data-id="element-11357">
      {children}
    </button>;
};
export const TabsContent: React.FC<{
  value: string;
  children: React.ReactNode;
  className?: string;
}> = ({
  value,
  children,
  className = ''
}) => {
  const context = useContext(TabsContext);
  if (!context) throw new Error('TabsContent must be used within a Tabs component');
  const {
    value: selectedValue
  } = context;
  if (selectedValue !== value) return null;
  return <div className={className} data-id="element-11358">{children}</div>;
};